import { render, staticRenderFns } from "./control_document.vue?vue&type=template&id=194adbf1&scoped=true"
import script from "./control_document.vue?vue&type=script&lang=js"
export * from "./control_document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194adbf1",
  null
  
)

export default component.exports